// SingleAccountField.tsx
import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { IAccount } from '../Interfaces/IAccount';

interface SingleAccountFieldProps {
    allAccounts: IAccount[];
    selectedAccount: IAccount | null;
    onChange: (newSelected: IAccount | null) => void;
    label: string;
    disabled: boolean;
}

const SingleAccountField: React.FC<SingleAccountFieldProps> = ({
                                                                   allAccounts,
                                                                   selectedAccount,
                                                                   onChange,
                                                                   label,
                                                                   disabled
                                                               }) => {
    return (
        <Autocomplete
            disableClearable
            disabled={disabled}

            options={allAccounts}

            // WICHTIG: Vergleich über ID (ohne das wird nie richtig gematcht)
            isOptionEqualToValue={(option, value) => option.id === value.id}

            getOptionLabel={(option: IAccount) => {
                const name = `${option.first_name || ''} ${option.last_name || ''}`.trim();
                return name || option.username;
            }}

            value={selectedAccount ?? undefined}


            onChange={(_, newValue) => onChange(newValue)}

            // WICHTIG: Key pro Option → verhindert "duplicate keys"
            renderOption={(props, option) => (
                <li {...props} key={option.id}>
                    {`${option.first_name} ${option.last_name}`.trim() || option.username}
                </li>
            )}

            renderInput={(params) => (
                <TextField {...params} label={label} variant="outlined" size="small" />
            )}
        />
    );
};

export default SingleAccountField;
